<script>
import axios from "axios";
import Swal from "sweetalert2";
import Layout from '../layouts/main';
import PageHeader from '@/components/page-header';
import RichTextEditor from '@/components/RichTextEditor.vue'
// import { authFackMethods } from "@/state/helpers";


export default {
  page: {
    title: "Editor Test",
    meta: [
      {
        name: "Editor Test",
      },
    ],
  },
  components: { Layout, PageHeader, RichTextEditor },
  data() {
    return {
      title: "",
      emailSubject: '',
      emailRecipient: '',
      emailContent: '<p>Hello World</p>',
      selectedTemplate: '',
      emailTemplates: [
        {
          id: 1,
          label: 'Template 1',
          content: `<p>Hi <span style="color: #e74c3c;">(FIRST NAME)</span>,</p> <p>Thank you for completing the volunteer application and thank you especially for your heart in considering coming alongside our clients as a volunteer! Our application is for us to learn a bit about you. The next form to complete is for the Department of Human Services, (DHS) who will beconducting your background check.</p> <p>Please read the following instructions carefully and complete the action steps (I recommend using a smart phone to complete steps 1 and 2):</p> <ol> <li>Fill out and sign the DHS Background Study Authorization Form that I will email to you shortly via DocuSign. DocuSign is a secure web-based signature program which streamlines our onboarding process.</li> <li>Make a photocopy or take a photograph of the front of your driver&rsquo;s license. You can do this via DocuSign as well.</li> </ol> <p>After I receive the required documents, I will email you some further instructions about completing the fingerprinting step of the DHS background check. If you have any questions regarding the DHS process, please review the DHS Privacy Practice Notice attached to the DocuSign email.</p> <p>If you have questions or if there is anything you would like to talk about at this point in the process, please feel free to give me a call or send me an email.&nbsp;</p> <p>Thanks,</p>`
        },
        {
          id: 2,
          label: 'Template 2',
          content: `<p><span style="font-size: 12pt;">Hi <span style="color: #e74c3c;">Volunteer</span>,&nbsp;</span></p> <p><span style="font-size: 12pt;">Thank you for completing your DHS authorization forms! The next step is for you to schedule a fingerprinting appointment at a location near you, once MnTC initiates the background study. We will do that within the next few business days, and you will be alerted by receiving an email from theDHS (see instructions below). Once you receive that email, you must complete fingerprinting within 14 days. <strong>This step is required to volunteer, and MnTC pays for this process so there is no cost to you (use the code below).</strong></span></p> <p><span style="font-size: 12pt;">Please complete the following steps as soon as possible, and no later than 14 days from the time you receive the email from the DHS:</span></p> <p><span style="font-size: 12pt;"><strong>1. Online Consent and Disclosure Form:</strong></span></p> <ol> <li style="font-size: 12pt;"><span style="font-size: 12pt;">You will receive an e-mail from DHS to complete a consent and disclosure form. The email will come from <a href="mailto:dhs.netstudy2@state.mn.us">dhs.netstudy2@state.mn.us</a>. The subject will read: ACTION REQUIRED - Your background study request has been submitted - NETStudy2</span></li> <li style="font-size: 12pt;"><span style="font-size: 12pt;">Complete the Consent and Disclosure form.</span></li> </ol> <p><span style="font-size: 12pt;"><strong>2. Online Pre-Enrollment:</strong></span></p> <ol> <li style="font-size: 12pt;"><span style="font-size: 12pt;">You will also receive an email from IDEMIA/IdentoGO (the fingerprinting contractor company) to complete fingerprint pre-enrollment and to schedule a fingerprint appointment.</span></li> <li style="font-size: 12pt;"><span style="font-size: 12pt;">The e-mail is from: <a href="mailto:nobody@uemail.identogo.com">nobody@uemail.identogo.com</a>. The subject will read: IdentoGO Service Confirmation &ndash; MN DHS Background Study</span></li> <li style="font-size: 12pt;"><span style="font-size: 12pt;">Complete the pre-enrollment form, which will include setting up a login and scheduling a time to be fingerprinted at a location near you.</span></li> </ol> <p><span style="font-size: 12pt;"><strong>3. At the Fingerprinting Location:</strong></span></p> <ol> <li style="font-size: 12pt;"><span style="font-size: 12pt;">Bring your ID to the fingerprint location and arrive at the time/date you scheduled.</span></li> <li style="font-size: 12pt;"><span style="font-size: 12pt;">The fingerprint technician will verify your information and will take your fingerprints and photograph.</span></li> <li style="font-size: 12pt;"><span style="font-size: 12pt;">At the fingerprinting location, you&rsquo;ll be required to sign an acknowledgment form that fingerprints will be used for state and federal criminal history check(s).</span></li> <li style="font-size: 12pt;"><span style="font-size: 12pt;">Give this authorization code to the fingerprint technician to use as payment at the fingerprinting location: <span style="color: #e74c3c;">xxxxxCODExxxxxxx</span> <strong>(Bring this code with you)</strong></span></li> </ol> <p><span style="font-size: 12pt;">If you do not receive the emails from the DHS and/or IDEMIA/IdentoGO within the next few days, please check your spam/junk folder. If you still have not received the emails, please contact me to let me know.</span></p> <p><span style="font-size: 12pt;">Once you have been fingerprinted, the DHS will send MnTC their determination. At that point, I will be in touch about the final steps of the process.</span></p> <p><span style="font-size: 12pt;">If you have any questions, don&rsquo;t hesitate to reach out.</span><br><span style="font-size: 12pt;">Thanks,</span></p>`
        }
      ],
      isBusy: false,
    }
  },
  mounted() {
  },
  methods: {
    onTemplateSelection() {
      let component = this;
      if (component.selectedTemplate) {
        component.emailContent = component.selectedTemplate;
      }
    },
    sendTestEmail() {
      let component = this;

      // check subject
      if (!component.emailSubject) {
        Swal.fire({
          title: "Error!",
          text: 'Email subject is required',
          icon: "error",
          width: 350,
          showConfirmButton: true
        });
        return;
      }

      // check recipient
      if (!component.emailRecipient) {
        Swal.fire({
          title: "Error!",
          text: 'A valid email address is required in the recipient field',
          icon: "error",
          width: 350,
          showConfirmButton: true
        });
        return;
      }

      // check content
      if (!component.emailContent) {
        Swal.fire({
          title: "Error!",
          text: 'Email content is required',
          icon: "error",
          width: 350,
          showConfirmButton: true
        });
        return;
      }

      component.isBusy = true;

      let requestBody = {};
      requestBody.email_subject = component.emailSubject;
      requestBody.email_recipient = component.emailRecipient;
      requestBody.email_content = component.emailContent;

      // make request
      var token = localStorage.getItem('token');
      var config = {
        headers: {
          Authorization: 'Bearer ' + token,
          'Accept': 'application/json'
        }
      };

      if (!token) {
        Swal.fire({
          title: "Error!",
          text: 'No auth token available',
          icon: "error",
          width: 350,
          showConfirmButton: true
        });
        component.isBusy = false;
        return;
      }

      axios.post('/admin/test-email', requestBody, config)
        .then((res) => {
          if (res.status == 200) {
            Swal.fire({
              title: "Success!",
              text: "Email sent successfully!",
              icon: "success",
              width: 350,
              showConfirmButton: false,
              timer: 1500
            });
          }
          component.isBusy = false;
        })
        .catch((err) => {
          if (err.response) {
            Swal.fire({
              title: "Error!",
              text: err.response.data.error.message,
              icon: "error",
              width: 350,
              showConfirmButton: true
            });
          }
          component.isBusy = false;
        })
    },
    onFormSubmit() {
      this.sendTestEmail();
    }
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="container-fluid pb-5">
      <div class="row">
        <div class="col">
          <div class="card card-body">
            <h5 class="card-title mb-3">Editor Test</h5>
            <form @submit.prevent="onFormSubmit">
              
              <div class="mb-3">
                <label for="email-subject" class="form-label">Email Subject</label>
                <input type="text" class="form-control" id="email-subject" v-model="emailSubject">
              </div>

              <div class="mb-3">
                <label for="email-recipient" class="form-label">Email Recipient</label>
                <input type="email" class="form-control" id="email-recipient" v-model="emailRecipient">
              </div>
              
              <div class="mb-3">
                <label class="form-label">Predefined Templates</label>
                <div>
                  <div class="form-check form-check-inline" v-for="(template, index) in emailTemplates" :key="index">
                    <input class="form-check-input" name="email-template" type="radio" :id="template.id" :value="template.content" v-model="selectedTemplate" @change="onTemplateSelection">
                    <label class="form-check-label" :for="template.id">{{ template.label }}</label>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="email-body" class="form-label">Email Body</label>
                <RichTextEditor cssClasses="form-control" v-model="emailContent"/>
              </div>

              <div class="mb-3">
                <label class="form-label">Generated Markup</label>
                <div>
                  <textarea style="width: 100%;" rows="30" v-model="emailContent"></textarea>
                </div>
              </div>

              <button type="submit" class="btn btn-primary" :disabled="isBusy == true">Send</button>

            </form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>